<template>
  <div class="detail_page">
    <div class="w">
      <!-- 分析师信息 -->
      <div class="information clearfix">
        <div
          class="analyst_bg"
          :style="{backgroundImage:'url(https://static.jiil1.com/154477095448237.png)'}"
        ></div>
        <div class="head-portrait">
          <img :src="info.face" />
        </div>
        <div class="information-content">
          <div class="mine_photos">
            <img v-for="item in info.imgs" :src="item.img" :title="item.content" />
          </div>
          <p class="name">
            <span>{{info.username}}</span>
            <img src="//static.jiil1.com/static/image/sex-men.png" v-if="info.sex==1" />
            <img src="//static.jiil1.com/static/image/sex-women.png" v-else />
          </p>
          <p class="position">
            {{info.level}}：
            <span>{{info.red}}%</span>
          </p>
          <p class="brief">
            <span>简介：</span>
            <span class="brief_content">{{info.content}}</span>
          </p>
        </div>
        <div class="anslyst-ma">
          <p>
            <img src="//static.jiil1.com/static/image/voice.png" />
            <span class="anltalk">{{info.slogan}}</span>
          </p>
          <div>
            <img :src="info.qcode" />
          </div>
        </div>
      </div>

      <div class="analysis">
        <div>
          <ul class="clearfix">
            <li
              v-for="(item,index) in newsLi"
              :key="index"
              :class="{'af-active':index === newsIndex}"
              @click="nhFun(index)"
            >{{item}}</li>
          </ul>
        </div>
        <div class="red_line"></div>
      </div>
      <div class="analysis1">
        <div class="analysis-content">
          <button
            v-for="(item,index) in viewLi"
            :class="{'view_active':index === viewIndex}"
            @click="seeFun(index)"
          >{{item}}</button>

          <table cellspacing="0" class="title">
            <tbody>
              <tr>
                <td class="f1">赛事</td>
                <td class="f2">时间</td>
                <td class="f3">状态</td>
                <td class="f4">主场球队</td>
                <td class="f5">比分</td>
                <td class="f6">客场球队</td>
                <td class="f7">推荐球队</td>
                <td class="f8">推荐比分</td>
                <td class="f9">推荐欧盘</td>
              </tr>
            </tbody>
          </table>
          <div class="analysis-content1"></div>
          <div class="analysis-content2"></div>
          <div class="end_bottom">已到底部</div>
          <div class="more_recommend" @click="moreRecommendFun(page,type,type1)" :page="page">
            <a>查看更多&nbsp∨</a>
          </div>
        </div>
      </div>
      <!-- 分析师动态 -->
      <div class="analystSay clearfix" v-if="dongtai">
        <h1>分析师说</h1>
        <div class="red_line">
          <span
            target="_blank"
            class="pointer"
            @click="totuijianlink(dongtai[0].member_id)"
          >查看更多分析师动态</span>
        </div>
        <div class="analystSay-bigcontent">
          <div
            class="analystSay-content"
            v-for="value in dongtai"
            :praise="value.praise"
            :blog_id="value.blog_id"
          >
            <div v-if="value.images!=null">
              <p>{{value.content}}</p>
              <div class="view_photos" v-if="value.images.length>2">
                <ul class="clearfix view_photo">
                  <li v-for="result in value.images.length">
                    <img :src="value.images[result-1]" />
                  </li>
                </ul>
                <div class="more_img">更多({{value.images.length}})</div>
              </div>
              <div class="view_photos" v-else>
                <ul class="clearfix view_photo">
                  <li v-for="result in value.images.length">
                    <img :src="value.images[result-1]" />
                  </li>
                </ul>
              </div>
              <div>
                <span>{{value.createtime}}</span>
                <img src="//static.jiil1.com/static/image/zan.png" class="getzan" iszan="0" />
              </div>
            </div>
            <div v-else>
              <p>{{value.content}}</p>
              <div class="view_photos">
                <ul class="clearfix"></ul>
              </div>
              <div>
                <span>{{value.createtime}}</span>
                <img src="//static.jiil1.com/static/image/zan.png" class="getzan" iszan="0" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 查看更多图片 -->
    <div class="wrapper">
      <div class="content">
        <div class="view">
          <img src="//static.jiil1.com/static/image/photo3.png" alt />
        </div>
        <div class="nav-left-thumbs">
          <img src="//static.jiil1.com/static/image/left.png" />
        </div>
        <div class="thumbs">
          <div class="pics-thumbs"></div>
        </div>
        <div class="nav-right-thumbs">
          <img src="//static.jiil1.com/static/image/right.png" />
        </div>
        <div class="close_btn">
          <img
            src="//static.jiil1.com/static/image/close.png"
            class="close_btn_img"
            @click="closeFun()"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
export default {
  data() {
    return {
      info: {},
      tag: {},
      photo: [],
      dongtai: [],
      recommend: [],
      newsLi: ["最新推荐", "历史推荐"],
      newsIndex: 0,
      viewLi: ["全部", "只看足球", "只看篮球"],
      viewIndex: 0,
      recommend: String,
      page: 1,
      type: 0, //查看更多默认0是最新推荐,1是历史推荐
      type1: "", //查看更多默认""全部,1是足球，2篮球
      params: {},
      headCon: headCon(),
    };
  },
  created() {
    this.params = this.$route.query;
    var num = 5;
    if (this.params.recommend_id) {
      num = 30;
    }
    var day = 1;
    if (parseInt(this.params.newsIndex) == 1) {
      day = 0;
    }
    this.request(
      "analystdetail?member_id=" + this.params.member_id,
      this.getInfo
    ); //分析师信息
    this.request(
      "analyst?member_id=" + this.params.member_id + "&num=2",
      this.getDongtai
    ); //分析师动态
    this.request(
      "luckball_pc?member_id=" +
        this.params.member_id +
        "&page=1" +
        "&num=" +
        num +
        "&day=" +
        day,
      this.getRecommend
    ); //幸运球场显示推荐
  },
  beforeMount() {
    var wx_login_t = this.$route.query.wx_login_t;
    if (wx_login_t) {
      var href = location.href;
      if (location.href.indexOf("&") == -1) {
        href = href.replace("?wx_login_t=" + wx_login_t, "");
      } else {
        href = href.replace("&wx_login_t=" + wx_login_t, "");
        href = href.replace("wx_login_t=" + wx_login_t + "&", "");
      }
      history.pushState("", "", href);
    }
  },
  mounted: function () {
    //钩子
    $(".haed_tuijian").addClass("nuxt-link-exact-active");
    this.viewNhFun();
    this.seeDphotoFun();
    if (this.params.newsIndex) {
      this.type = parseInt(this.params.newsIndex);
      this.newsIndex = parseInt(this.params.newsIndex);
    }
  },
  methods: {
    request(url, fn) {
      url = COMMOND.NEW_BASE_URL + url;
      axios.get(url).then((res) => {
        if (fn) {
          fn(res.data);
        }
      });
    },
    getInfo(data) {
      this.info = data.data;
      this.$nextTick(function () {
        var title = this.headCon["tuijian"]["football-analyst"]["title"];
        this.headCon["tuijian"]["football-analyst"]["title"] = title.replace(
          "{username}",
          this.info.username
        );
        $("footer").css("display", "inline-block");
      });
    },
    getTag(data) {
      this.tag = data.result;
    },
    getPhoto(data) {
      this.photo = data.result;
    },
    getDongtai(data) {
      this.dongtai = data.data;
      this.$nextTick(function () {
        this.zanFun();
      });
    },
    getRecommend(data) {
      this.recommend = data.data;
      this.recommendErrno = data.code;
      if (!this.newsIndex) {
        this.recommendFun(1);
      } else {
        this.recommendFun();
      }
    },
    totuijianlink(id) {
      window.open(
        window.location.protocol +
          "//" +
          window.location.host +
          "/tuijian/analyst-talk?member_id=" +
          id
      );
    },
    axiosFun(page, day, type, recommend_id) {
      //分析师列表数据
      var member_id = this.params.member_id;
      var url = "luckball_pc";
      if (day) {
        url +=
          "?member_id=" +
          member_id +
          "&page=" +
          page +
          "&num=5" +
          "&type=" +
          type +
          "&day=" +
          day +
          "&recommend_id=" +
          this.params.recommend_id;
      } else {
        url +=
          "?member_id=" +
          member_id +
          "&page=" +
          page +
          "&num=5" +
          "&type=" +
          type;
      }
      this.request(url, this.getRecommend); //幸运球场显示推荐
    },
    scroll(recommend_id) {
      var football = $(".football_content[recommend_id=" + recommend_id + "]");
      var basketball = $(
        ".basketball_content[recommend_id=" + recommend_id + "]"
      );
      if (football.length > 0) {
        $(document).scrollTop(football.offset().top);
      }
      if (basketball.length > 0) {
        $(document).scrollTop(basketball.offset().top);
      }
    },
    nhFun(index) {
      //最新/历史推荐
      var that = this;
      this.newsIndex = index;
      if (index == 0) {
        //今日推荐0 历史推荐1
        that.page = 1; //切换最新和历史推荐还原页数;
        that.type = 0; //0是今日 1是历史
        that.viewIndex = 0;
        $(".football").remove();
        $(".basketball").remove();
        that.axiosFun(that.page, 1);
      } else {
        that.page = 1;
        that.type = 1;
        that.viewIndex = 0;
        $(".football").remove();
        $(".basketball").remove();
        that.axiosFun(that.page);
      }
    },

    seeFun(index) {
      //查看全部查看足球查看篮球
      var that = this;
      this.viewIndex = index;
      if (index == 0) {
        that.page = 1; //第一页;
        that.type1 = "";
        //0是今日 1是历史
        $(".football").remove();
        $(".basketball").remove();
        if (that.type == 0) {
          that.axiosFun(that.page, 1);
        } else {
          that.axiosFun(that.page);
        }
      } else if (index == 1) {
        that.page = 1;
        that.type1 = 1;
        $(".football").remove();
        $(".basketball").remove();
        if (that.type == 0) {
          that.axiosFun(that.page, 1, 1);
        } else {
          that.axiosFun(that.page, "", 1);
        }
      } else {
        that.page = 1;
        that.type1 = 2;
        $(".football").remove();
        $(".basketball").remove();
        if (that.type == 0) {
          that.axiosFun(that.page, 1, 2);
        } else {
          that.axiosFun(that.page, "", 2);
        }
      }
    },
    moreRecommendFun(page, type, type1) {
      //分析是更多推荐
      var that = this;
      that.page = page + 1;
      if (type == 0) {
        //今日推荐
        if (that.viewIndex == 0) {
          that.axiosFun(that.page, 1);
        } else if (that.viewIndex == 1) {
          that.axiosFun(that.page, 1, 0);
        } else if (that.viewIndex == 2) {
          that.axiosFun(that.page, 1, 1);
        }
      } else if (type == 1) {
        //历史推荐
        if (that.viewIndex == 0) {
          that.axiosFun(that.page, "");
        } else if (that.viewIndex == 1) {
          that.axiosFun(that.page, "", 0);
        } else if (that.viewIndex == 2) {
          that.axiosFun(that.page, "", 1);
        }
      }
    },
    recommendFun(day) {
      //分析师推荐信息渲染
      var prizeName = "未知,正确,错误,平局".split(",");
      var stateName = {
        "0": "未开",
        "1": "上半场",
        "2": "中场",
        "3": "下半场",
        "4": "加时",
        "5": "点球",
        "-1": "完场",
        "-10": "取消",
        "-11": "待定",
        "-12": "腰斩",
        "-13": "中断",
        "-14": "推迟",
      };
      var stateBkName = {
        "0": "未开赛",
        "1": "第一节",
        "2": "第二节",
        "3": "第三节",
        "4": "第四节",
        "5": "加时",
        "6": "加时",
        "7": "加时",
        "-1": "完场",
        "-2": "待定",
        "-3": "中断",
        "-4": "取消",
        "-5": "推迟",
        "50": "中场",
      };
      var that = this;
      var result = that.recommend;
      var _str = "";
      var errno = that.recommendErrno;
      console.log(result);
      if (errno == 200) {
        if (result) {
          $(".more_recommend").show();
          $(".end_bottom").hide();
          $(".no_result").remove();
          var str = "";
          for (var i = 0; i < result.length; i++) {
            console.log("aaaa");
            //							if(!result[i].price) {
            //							result[i].prize_zh = prizeName[result[i].prize]; //赛事结果转中文
            //							var result_content = ""
            //							if(result[i].prize_zh == "正确") {
            //								result_content = `<img src="//static.jiil1.com/static/image/3.luckyStadium/right_icon.png"><span class="right">` + result[i].prize_zh + `</span>`
            //							} else if(result[i].prize_zh == "错误") {
            //								result_content = `<img src="//static.jiil1.com/static/image/3.luckyStadium/wrong_icon.png"><span class="wrong">` + result[i].prize_zh + `</span>`
            //							} else if(result[i].prize_zh == "未知") {
            //								result_content = `<img src="//static.jiil1.com/static/image/3.luckyStadium/unknow_icon.png"><span class="unknow">` + result[i].prize_zh + `</span>`
            //							} else if(result[i].prize_zh == "平局") {
            //								result_content = `<img src="//static.jiil1.com/static/image/3.luckyStadium/jun_icon.png"><span class="jun">` + result[i].prize_zh + `</span>`
            //							}

            if (result[i].type == 1) {
              str =
                ` <div class="football">
	                                        <div class="football_content not" state=` +
                result[i].state +
                ` recommend_id=` +
                result[i].recommend_id +
                `>
                                            <table cellspacing="0">
                                            <tbody>
                                        	<tr>
                                            <td class="f1 need_gradient" >` +
                result[i].league_name_zh +
                `</td>
                                            <td class="f2" >` +
                result[i].matches_time +
                `</td>
                                            <td class="f3"> ` +
                stateName[result[i].state] +
                `</td>
                                            <td class="f4"><span class="hyellow_pai">` +
                result[i].home_yellow +
                `</span><span class="hred_pai">` +
                result[i].home_red +
                `</span>` +
                result[i].home_name_zh +
                `</td>
                                            <td class="f5">` +
                result[i].home_score +
                `-` +
                result[i].away_score +
                `</td>
                                            <td class="f6">` +
                result[i].away_name_zh +
                `<span class="ared_pai">` +
                result[i].away_red +
                `</span><span class="ayellow_pai">` +
                result[i].away_yellow +
                `</span></td>
                                            <td class="f7">`;
              var pTrue = false;
              if (result[i].state >= 0 && result[i].state <= 5) {
                pTrue = true;
              }
              if (result[i].price && pTrue) {
                str +=
                  '<img src="//static.jiil1.com/static/image/lock.png" width="20px">';
              } else {
                str +=
                  '<span class="red-word">' + result[i].seleltname + "</span>";
              }
              str += `</td>
                                        <td class="f8">`;

              if (result[i].price && pTrue) {
                str +=
                  '<img src="//static.jiil1.com/static/image/lock.png" width="20px">';
              } else {
                var sore = "";
                if (!result[i].sore) {
                  sore = "暂无推荐";
                } else {
                  sore = result[i].sore.replace("/", "或");
                }
                str += sore;
              }
              str += `</td>
                                    	<td class="f9">`;
              if (result[i].price && pTrue) {
                str +=
                  '<img src="//static.jiil1.com/static/image/lock.png" width="20px">';
              } else {
                var re = "";
                if (!result[i].recommend) {
                  re = "暂无推荐";
                } else {
                  var oRecommend = result[i].recommend.split(",");
                  for (var j = 0; j < oRecommend.length; j++) {
                    if (j == 0) {
                      if (oRecommend[0] == 1) {
                        re = "胜";
                      } else if (oRecommend[0] == 2) {
                        re = "负";
                      } else if (oRecommend[0] == 3) {
                        re = "平";
                      }
                    }
                    if (j == 1) {
                      re += "或";
                      if (oRecommend[1] == 1) {
                        re += "胜";
                      } else if (oRecommend[1] == 2) {
                        re += "负";
                      } else if (oRecommend[1] == 3) {
                        re += "平";
                      }
                    }
                  }
                }
                str += re;
              }
              str += `</td>
                                        </tr>
                                        <tr>
										<td colspan="9" >`;
              if (result[i].is_hit == 1) {
                str +=
                  '<img class="hit" src="//static.jiil1.com/static/image/hit.png">';
              } else if (result[i].is_hit == 2) {
                str +=
                  '<img class="hit" src="//static.jiil1.com/static/image/nohit.png">';
              }
              if (result[i].price && pTrue) {
                str +=
                  '<a class="lock" href="/app"><div><img src="//static.jiil1.com/static/image/lock.png" width="30px"></div><div class="hint"><span>看推文分析请点击下载</span><span style="color:red;">APP</span></div></a>';
              } else {
                str +=
                  `<span >推荐理由：</span>
	                                        <p>` +
                  result[i].content +
                  `</p>
	                                        <div><img src="//static.jiil1.com/static/image/have-zan.png" class="like"  isclick="0"><span class="like_num">` +
                  result[i].praise +
                  `</span>人<img src="//static.jiil1.com/static/image/zan.png" class="unlike"  isclick="0"><span class="nolike_num">` +
                  result[i].nolike +
                  `</span>人</div>
	                                        `;
              }
              str += `<div class="football-bg"><img src="//static.jiil1.com/static/image/3.luckyStadium/football-bg1.png"></div></td>
                                        </tr>
	                                    </tbody>
		                                </table>
			                            </div>
				                        </div>`;
            } else if (result[i].type == 2) {
              var away_one = result[i].away_one_score
                ? result[i].away_one_score
                : 0;
              var away_two = result[i].away_two_score
                ? result[i].away_two_score
                : 0;
              var away_three = result[i].away_three_score
                ? result[i].away_three_score
                : 0;
              var away_four = result[i].away_four_score
                ? result[i].away_four_score
                : 0;
              var home_one = result[i].home_one_score
                ? result[i].home_one_score
                : 0;
              var home_two = result[i].home_two_score
                ? result[i].home_two_score
                : 0;
              var home_three = result[i].home_three_score
                ? result[i].home_three_score
                : 0;
              var home_four = result[i].home_four_score
                ? result[i].home_four_score
                : 0;
              var changci = "";
              var home_bifen = "";
              var away_bifen = "";
              if (
                result[i].home_overtime_one_score ||
                result[i].home_overtime_two_score ||
                result[i].home_overtime_three_score ||
                result[i].away_overtime_one_score ||
                result[i].away_overtime_two_score ||
                result[i].away_overtime_three_score
              ) {
                changci = `<span >1</span><span >2</span><span >3</span><span>4</span><span >ot</span>`;
                away_bifen =
                  `<span>` +
                  away_one +
                  `</span><span>` +
                  away_two +
                  `</span><span>` +
                  away_three +
                  `</span><span>` +
                  away_four +
                  `</span><span>` +
                  (result[i].away_overtime_one_score +
                    result[i].away_overtime_two_score +
                    result[i].away_overtime_three_score) +
                  `</span>`;
                home_bifen =
                  `<span>` +
                  home_one +
                  `</span><span>` +
                  home_two +
                  `</span><span>` +
                  home_three +
                  `</span><span>` +
                  home_four +
                  `</span><span>` +
                  (result[i].home_overtime_one_score +
                    result[i].home_overtime_two_score +
                    result[i].home_overtime_three_score) +
                  `</span>`;
              } else {
                changci = `<span >1</span><span >2</span><span >3</span><span>4</span>`;
                away_bifen =
                  `<span>` +
                  away_one +
                  `</span><span>` +
                  away_two +
                  `</span><span>` +
                  away_three +
                  `</span><span>` +
                  away_four +
                  `</span>`;
                home_bifen =
                  `<span>` +
                  home_one +
                  `</span><span>` +
                  home_two +
                  `</span><span>` +
                  home_three +
                  `</span><span>` +
                  home_four +
                  `</span>`;
              }

              str =
                `<div class="basketball"> 
                                			<div class="basketball_content" state=` +
                result[i].state +
                ` recommend_id=` +
                result[i].recommend_id +
                `>
                                            <div class=""></div>
                                            <div class=""></div>
                                            <table cellspacing="0">
                                            <tbody>
                                            <tr class="basketball1">
                                            <td rowspan="3" class="b1">
                                                <p>` +
                result[i].matches_time +
                `</p>
                                                <p>` +
                stateBkName[result[i].state] +
                `</p>
                                            </td>
                                            <td class="b2"  >
                                                <span></span>` +
                result[i].league_name_zh +
                `
                                            </td>
                                            <td class="b3 " >
                                                ` +
                changci +
                `
                                            </td>
                                            <td class=" b4" >
                                                <span >半场</span>
                                                <span >全场</span>
                                                <span >分差</span>
                                                <span >总分</span>
                                            </td>
                                            <td class=" b5" >推荐球队</td>
                                            <td class=" b6" >推荐比分</td>
                                            <td class=" b7" >推荐欧盘</td>
                                            </tr>
                                            <tr class="basketball2">
                                            <td class="b2">
                                                <span class="guest">客</span>` +
                result[i].away_name_zh +
                `
                                            </td>
                                            <td class="b3" >
                                                ` +
                away_bifen +
                `
                                            </td>
                                            <td class="b4">
                                                <span > ` +
                (away_one + away_two) +
                `/` +
                (away_three + away_four) +
                `</span>
                                                <span >` +
                result[i].away_score +
                `</span>
                                                <span > 总：` +
                (result[i].home_score - result[i].away_score) +
                `</span>
                                                <span > 总：` +
                (result[i].home_score + result[i].away_score) +
                `</span>
                                            </td>
                                            <td class="b5" rowspan="2" >`;

              var pTrue = false;
              if (result[i].state >= 0 && result[i].state <= 7) {
                pTrue = true;
              }
              if (result[i].price && pTrue) {
                str +=
                  '<img src="//static.jiil1.com/static/image/lock.png" width="20px">';
              } else {
                str += "<span >" + result[i].seleltname + "</span>";
              }
              str += `</td>
                                            <td class="b6" rowspan="2">`;

              if (result[i].price && pTrue) {
                str +=
                  '<img src="//static.jiil1.com/static/image/lock.png" width="20px">';
              } else {
                var sore = "";
                //	                                    	console.log(typeof(result[i].sore))
                if (!result[i].sore) {
                  //		                                    	console.log("bbb")
                  sore = "暂无推荐";
                } else {
                  sore = result[i].sore.replace("/", "或");
                }
                str += "<span >" + sore + "</span>";
              }
              str += `</td>
                                        	<td class="b7" rowspan="2">`;

              if (result[i].price && pTrue) {
                str +=
                  '<img src="//static.jiil1.com/static/image/lock.png" width="20px">';
              } else {
                var re = "";
                if (!result[i].recommend) {
                  re = "暂无推荐";
                } else {
                  var oRecommend = result[i].recommend.split(",");
                  for (var j = 0; j < oRecommend.length; j++) {
                    if (j == 0) {
                      if (oRecommend[0] == 1) {
                        re = "胜";
                      } else if (oRecommend[0] == 2) {
                        re = "负";
                      } else if (oRecommend[0] == 3) {
                        re = "平";
                      }
                    }
                    if (j == 1) {
                      re += "或";
                      if (oRecommend[1] == 1) {
                        re += "胜";
                      } else if (oRecommend[1] == 2) {
                        re += "负";
                      } else if (oRecommend[1] == 3) {
                        re += "平";
                      }
                    }
                  }
                }
                str += re;
              }
              str +=
                `</td>
                                            </tr>
                                            <tr class="basketball2">
                                            <td class="b2">
                                                <span class="host">主</span>` +
                result[i].home_name_zh +
                `
                                            </td>
                                            <td class="b3" >
                                                ` +
                home_bifen +
                `
                                            </td>
                                            <td class="b4">
                                                <span > ` +
                (home_one + home_two) +
                `/` +
                (home_three + home_four) +
                ` </span>
                                                <span >` +
                result[i].home_score +
                `</span>
                                                <span > 半：` +
                (home_one + home_two - (away_one + away_two)) +
                `</span>
                                                <span > 半：` +
                (home_one + home_two + (away_one + away_two)) +
                `</span>
                                            </td>
                                            </tr>
                                            <tr>
                                            <td colspan="7" class="" >`;
              if (result[i].is_hit == 1) {
                str +=
                  '<img class="hit" src="//static.jiil1.com/static/image/hit.png">';
              } else if (result[i].is_hit == 2) {
                str +=
                  '<img class="hit" src="//static.jiil1.com/static/image/nohit.png">';
              }
              if (result[i].price && pTrue) {
                str +=
                  '<a class="lock" href="/app"><div style="text-align: center;"><img src="//static.jiil1.com/static/image/lock.png" width="30px"></div><div class="hint"><span>看推文分析请点击下载</span><span style="color:red;">APP</span></div></a>';
              } else {
                str +=
                  `<span >推荐理由：</span>
                                                <p>` +
                  result[i].content +
                  `</p>
                                                <div><img src="//static.jiil1.com/static/image/have-zan.png" class="like" isclick="0"><span class="like_num">` +
                  result[i].praise +
                  `</span>人<img src="//static.jiil1.com/static/image/zan.png" class="unlike"  isclick="0"><span class="nolike_num">` +
                  result[i].nolike +
                  `</span>人</div>`;
              }
              str += `</td>
                                            </tr>
                                       	 	</tbody>
                                    		</table>
                                			</div>
	                                    	</div>`;
            }
            $(".analysis-content1").append(str);
            //足球
            var contentChild = $(".analysis-content1").find(
              ".football_content"
            );
            //红黄牌的显示
            for (var k = 0; k < contentChild.length; k++) {
              contentChild.eq(k + 1).addClass("football_content");
              var state = contentChild.eq(k).attr("state");
              var hred_pai = contentChild.eq(k).find(".hred_pai").html();
              var hyellow_pai = contentChild.eq(k).find(".hyellow_pai").html();
              var ared_pai = contentChild.eq(k).find(".ared_pai").html();
              var ayellow_pai = contentChild.eq(k).find(".ayellow_pai").html();
              if (hred_pai == 0) {
                contentChild.eq(k).find(".hred_pai").hide();
              }
              if (hyellow_pai == 0) {
                contentChild.eq(k).find(".hyellow_pai").hide();
              }
              if (ared_pai == 0) {
                contentChild.eq(k).find(".ared_pai").hide();
              }
              if (ayellow_pai == 0) {
                contentChild.eq(k).find(".ayellow_pai").hide();
              }
              if (state == 1 || state == 0) {
                contentChild.eq(k).addClass("not");
              } else if (state > 1 && state < 8) {
                contentChild.eq(k).addClass("ing");
              } else if (state == 8) {
                contentChild.eq(k).addClass("haved");
              } else if (state > 8 && state < 14) {
                contentChild.eq(k).addClass("not");
              }
            }
            //篮球
            var contentChild1 = $(".analysis-content1").find(
              ".basketball_content"
            );
            for (var k = 0; k < contentChild1.length; k++) {
              var state = contentChild1.eq(k).attr("state");
              contentChild1.eq(k + 1).addClass("basketball_content");
              if (state == 1 || state == 0) {
                contentChild1.eq(k).addClass("not");
                contentChild1
                  .eq(k)
                  .children(":nth-child(1)")
                  .addClass("not_bg");
              } else if (state > 1 && state < 10) {
                contentChild1.eq(k).addClass("ing");
                contentChild1
                  .eq(k)
                  .children(":nth-child(1)")
                  .addClass("ing_bg");
              } else if (state == 10) {
                contentChild1.eq(k).addClass("haved");
                contentChild1
                  .eq(k)
                  .children(":nth-child(1)")
                  .addClass("haved_bg");
              } else if (state > 10 && state < 14) {
                contentChild1.eq(k).addClass("not");
                contentChild1
                  .eq(k)
                  .children(":nth-child(1)")
                  .addClass("not_bg");
              }
            }
          }
        } else {
          if (day) {
            var _str = `<div class="no_result"><img src="//static.jiil1.com/static/image/no_result.png"><p class="see_history">查看历史推荐</p></div>`;
            $(".more_recommend").hide();
            $(".analysis-content2").html(_str);
            $(".end_bottom").hide();
          } else {
            var _str = `<div class="no_result"><img src="//static.jiil1.com/static/image/no_result.png"><p class="see_today">查看最新推荐</p></div>`;
            $(".more_recommend").hide();
            $(".analysis-content2").html(_str);
            $(".end_bottom").hide();
          }
        }
        if (this.params.recommend_id) {
          this.page = 6;
          this.scroll(this.params.recommend_id);
        }
      } else {
        $(".more_recommend").hide();
        $(".end_bottom").show();
      }
    },

    viewNhFun(index) {
      //底部查看历史和查看今日
      var that = this;
      $(".analysis-content2").on("click", ".see_history", function () {
        //历史
        that.page = 1; //切换最新和历史推荐还原页数;
        that.type = 1; //0是今日 1是历史
        that.viewIndex = 0;
        that.newsIndex = 1;
        $(".football").remove();
        $(".basketball").remove();
        that.axiosFun(that.page);
      });
      $(".analysis-content2").on("click", ".see_today", function () {
        //最新
        that.page = 1;
        that.type = 0;
        that.viewIndex = 0;
        that.newsIndex = 0;
        $(".football").remove();
        $(".basketball").remove();
        that.axiosFun(that.page, 1);
      });
    },

    seeDphotoFun() {
      //查看图片
      function view_img() {
        //查看图片
        var index = 0;
        var length = $(".pics-thumbs img").length - 1;
        $(".nav-left-thumbs img").attr(
          "src",
          "//static.jiil1.com/static/image/no_left.png"
        );
        if (length > 0) {
          $(".nav-right-thumbs img").attr(
            "src",
            "//static.jiil1.com/static/image/right.png"
          );
        } else {
          $(".nav-right-thumbs img").attr(
            "src",
            "//static.jiil1.com/static/image/no_right.png"
          );
        }
        $(".pics-thumbs img").eq(0).css("background", "#ccc");
        $(".pics-thumbs img").click(function () {
          var src = $(this).attr("src");
          index = $(this).index();
          //console.log(index)
          //console.log(src)
          if (index == 0) {
            $(".nav-left-thumbs img").attr(
              "src",
              "//static.jiil1.com/static/image/no_left.png"
            );
          } else {
            $(".nav-left-thumbs img").attr(
              "src",
              "//static.jiil1.com/static/image/left.png"
            );
          }
          if (index == length) {
            $(".nav-right-thumbs img").attr(
              "src",
              "//static.jiil1.com/static/image/no_right.png"
            );
          } else {
            $(".nav-right-thumbs img").attr(
              "src",
              "//static.jiil1.com/static/image/right.png"
            );
          }
          $(".view img").attr("src", src);
          $(".pics-thumbs").find("img").css("background", "#fff");
          $(".pics-thumbs img").eq(index).css("background", "#ccc");
        });
        $(".nav-right-thumbs").click(function () {
          if (index < length) {
            index++;
            var src = $(".pics-thumbs img").eq(index).attr("src");
            if (index == 0) {
              $(".nav-left-thumbs img").attr(
                "src",
                "//static.jiil1.com/static/image/no_left.png"
              );
            } else {
              $(".nav-left-thumbs img").attr(
                "src",
                "//static.jiil1.com/static/image/left.png"
              );
            }
            if (index == length) {
              $(".nav-right-thumbs img").attr(
                "src",
                "//static.jiil1.com/static/image/no_right.png"
              );
            } else {
              $(".nav-right-thumbs img").attr(
                "src",
                "//static.jiil1.com/static/image/right.png"
              );
            }
            $(".view img").attr("src", src);
            $(".pics-thumbs").find("img").css("background", "#fff");
            $(".pics-thumbs img").eq(index).css("background", "#ccc");
          }
        });
        $(".nav-left-thumbs").click(function () {
          if (index > 0) {
            index--;
            var src = $(".pics-thumbs img").eq(index).attr("src");
            if (index == 0) {
              $(".nav-left-thumbs img").attr(
                "src",
                "//static.jiil1.com/static/image/no_left.png"
              );
            } else {
              $(".nav-left-thumbs img").attr(
                "src",
                "//static.jiil1.com/static/image/left.png"
              );
            }
            if (index == length) {
              $(".nav-right-thumbs img").attr(
                "src",
                "//static.jiil1.com/static/image/no_right.png"
              );
            } else {
              $(".nav-right-thumbs img").attr(
                "src",
                "//static.jiil1.com/static/image/right.png"
              );
            }
            $(".view img").attr("src", src);
            $(".pics-thumbs").find("img").css("background", "#fff");
            $(".pics-thumbs img").eq(index).css("background", "#ccc");
          }
        });
      }

      function replacePhoto() {
        //查看图片的时候替换
        var src = $(".pics-thumbs img").eq(0).attr("src");
        $(".view img").attr("src", src);
      }

      function appearPhoto(dom) {
        //分析师动态显示图片
        $(".view_photos")
          .find(dom)
          .click(function () {
            if (dom == "li") {
              var parent1 = $(this).parent().parent();
            } else {
              var parent1 = $(this).parent();
            }
            var li1 = parent1.find("li");
            var img3 = "";

            for (var i = 0; i < li1.length; i++) {
              img3 += li1.eq(i).html();
            }
            $(".pics-thumbs").html(img3);
            $(".pics-thumbs img").eq(0).addClass("isactive1");
            $(".wrapper").show();
            replacePhoto();
            view_img();
          });
      }
      //点击动态的图片
      appearPhoto("li");

      //点击动态的图片更多
      appearPhoto(".more_img");

      //分析师头像相册
      $(".mine_photos").on("click", "img", function () {
        var photo_img = $(".mine_photos").html();
        // var img=''
        // for(var i=0;i<phote_img.length;i++){
        //     img += '<img src=" '+phote_img[i]+' " />'
        // }
        $(".pics-thumbs").html(photo_img);
        $(".wrapper").show();
        replacePhoto();
        view_img();
      });
    },

    closeFun() {
      //关闭查看图片
      $(".wrapper").hide();
    },

    zanFun() {
      //点赞

      var zan_content = "";

      function postzan(id, type, case1) {
        $.ajax({
          url: COMMOND.NEW_BASE_URL + "praise",
          data: {
            id: id,
            type: type,
            case: case1,
          },
          type: "GET",
          dataType: "JSON",
          async: false,
          success: function (data) {
            if (data.code == 200) {
              zan_content = data.code;
            } else {
              layer.msg(data.msg);
              zan_content = data.code;
            }
          },
        });
      }
      /*动态点赞*/
      $(".getzan").click(function () {
        var iszan = $(this).attr("iszan");
        if (iszan == 0) {
          $(this).attr("src", "//static.jiil1.com/static/image/have-zan.png");
          $(this).attr("iszan", "1");
          var blog_id = $(this).parent().parent().parent().attr("blog_id");
          postzan(blog_id, 0, 1);
        }
      });
      //分析内容喜欢
      $(".analysis-content1").on("click", ".like", function () {
        var id = $(this)
          .parent()
          .parent()
          .parent()
          .parent()
          .parent()
          .parent()
          .attr("recommend_id");
        var num = $(this).siblings(".like_num").html();
        postzan(id, 0, 0);
        if (zan_content == 200) {
          num = Number(num) + 1;
          $(this).siblings(".like_num").html(num);
        }
      });
      //分析内容不喜欢
      $(".analysis-content1").on("click", ".unlike", function () {
        var num = $(this).siblings(".nolike_num").html();
        num = Number(num) + 1;
        var id = $(this)
          .parent()
          .parent()
          .parent()
          .parent()
          .parent()
          .parent()
          .attr("recommend_id");
        postzan(id, 1, 0);
        if (zan_content == 200) {
          $(this).siblings(".nolike_num").html(num);
        }
      });
    },
    titleFun() {
      document.title = "121";
    },
  },
  metaInfo() {
    return {
      title: this.headCon["tuijian"]["football-analyst"]["title"],
      meta: [
        {
          hid: "description",
          name: "description",
          content: this.headCon["tuijian"]["football-analyst"]["description"],
        },
        {
          hid: "keywords",
          name: "keywords",
          content: this.headCon["tuijian"]["football-analyst"]["keywords"],
        },
      ],
    };
  },
};
</script>
<style>
@import "../../assets/css/detail-page.css";
@import "../../assets/css/t-analyst.css";
.analysis1 .end_bottom {
  display: none;
  font-size: 14px;
  color: #666;
  text-align: center;
  width: 140px;
  height: 30px;
  line-height: 30px;
  border-radius: 4px;
  margin: 0 auto;
  margin-top: 68px;
}
</style>